var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 71,
    viewBox: "0 0 171 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.404 71H0.249782C-3.00877 54.6665 26.6915 53.4415 26.6915 53.4415C15.2866 46.9081 18.9525 35.5087 18.9525 35.5087C27.0989 18.7669 48.2794 35.6789 48.2794 35.6789C45.8355 28.4649 51.538 4.37306 68.3059 0.493867C70.9874 -0.0846101 73.9405 -0.186697 77.199 0.357752C100.79 4.44112 98.3456 35.0664 98.3456 35.0664C98.3456 35.0664 119.934 14.6495 132.56 20.3663C145.187 26.083 130.116 45.2748 130.116 45.2748C185.885 28.533 168.404 71 168.404 71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.6e8e2ba6e292a45af29054cb9b770fb0.svg";
export { ForwardRef as ReactComponent };